export default __webpack_public_path__ + "static/media/021-speed limit.d6845db0.png";